import { formatDistanceToNow } from 'date-fns';

export function formatLogEntryFrequency(occurrenceCount: number, lastSeenAt: string): string {
  const relative = formatDistanceToNow(new Date(lastSeenAt), { addSuffix: true });
  return `Seen ${occurrenceCount}x · last ${relative}`;
}
